// extracted by mini-css-extract-plugin
export default {"badge":"BuildVersionBadge_badge__8CxSx"};